import React, {Fragment, useState, useEffect} from 'react';
import lodash from 'lodash';
import classnames from 'classnames';
import styles from './ExpectationsContent.scss';
import { ExpectationCard } from './common/ExpectationCard';
import SaveFixedFooter from 'pages/studyOverview/components/SaveFixedFooter';
import { 
    hasSelectedItem, 
    isAllSelected,
    isCategoryPartiallySelected,
    isChecked,
    toggleSingleCheckbox,
    isAllRolesSelectedForCategory,
    toggleCategoryCheckbox
} from './common/helperFunctions';

export default function Staff({
    staffDocumentExpectations, 
    studyRoles, 
    staffExpectationsGroupByName, 
    removeStudyExpectations
}) {
    const [toDelete, setToDelete] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    
    const isPartiallySelected = hasSelectedItem(staffDocumentExpectations, toDelete);
    const allStaffExpectationIds = lodash.map(staffDocumentExpectations, expectation => expectation.id);

    useEffect(() =>{
        if(selectAll){
            setToDelete( (toDelete) => 
                isPartiallySelected ? 
                    [] :
                    lodash.uniq([...toDelete, ...allStaffExpectationIds])
            );
        }else{
            !isPartiallySelected && setToDelete([]);
        }
    }, [selectAll]);

    useEffect(() => {
        const selectedAll = isAllSelected(staffDocumentExpectations, toDelete);

        if(selectedAll){
            setSelectAll(true);
        }else if(isPartiallySelected || lodash.isEmpty(toDelete)){
            setSelectAll(false);
        }
    }, [toDelete]);

    return (
        <Fragment>
            <div className={styles.container} data-cy="Staffs">
                {
                    !lodash.isEmpty(staffDocumentExpectations) ?
                        <ListStaffExpectations 
                            selectAll={selectAll}
                            setSelectAll={setSelectAll}
                            partiallySelected={isPartiallySelected}
                            toDelete={toDelete}
                            setToDelete={setToDelete}
                            studyRoles={studyRoles} 
                            allStaffExpectations={staffExpectationsGroupByName} 
                        /> :
                        <p>No staff expectations available. Go to expectations tab to get started.</p>
                }
            </div>
            <SaveFixedFooter
                disabled={lodash.isEmpty(toDelete)}
                onClick={() => {
                    removeStudyExpectations(toDelete),
                    setToDelete([]);
                }}
            >
                Remove
            </SaveFixedFooter>
        </Fragment>
        
    );
}

export const SelectAllExpectations = ({
    selectAll, 
    setSelectAll, 
    partiallySelected
}) => (
    <div className={classnames(
        styles.selectAll,
        {[styles.checked]: selectAll}
    )} data-cy="Staffs-div">
        <input
            name={'all'}
            type="checkbox"
            checked={selectAll}
            onChange={() => setSelectAll(selectAll => !selectAll)}
            ref={el => el && (el.indeterminate = partiallySelected)}
            data-cy="Staffs-input"
        />
        <span>Select All</span>
    </div>
);

export const ListStaffExpectations = ({
    selectAll, 
    setSelectAll, 
    partiallySelected, 
    studyRoles, 
    allStaffExpectations, 
    toDelete, 
    setToDelete
}) => {
    const getStudyRoleName = (id) => (studyRoles.find(role => role.id === id));

    return(
        <div className={styles.expectationList} data-cy="Staffs-ListStaffExpectations">
            <SelectAllExpectations 
                selectAll={selectAll} 
                setSelectAll={setSelectAll} 
                partiallySelected={partiallySelected} 
            />
            { lodash.map(allStaffExpectations, 
                (expectations, documentType) => {
                    
                    return(
                        <div key={documentType} className={styles.expectationBlock} data-cy={'Staffs-' + documentType}>
                            <ExpectationCard 
                                label={documentType} 
                                checked={isAllRolesSelectedForCategory(expectations, toDelete)}
                            >
                                <input
                                    name={documentType}
                                    type="checkbox"
                                    checked={isAllRolesSelectedForCategory(expectations, toDelete)}
                                    onChange={() => setToDelete(toDelete => toggleCategoryCheckbox(expectations, toDelete))}
                                    ref={el => el && (el.indeterminate = isCategoryPartiallySelected(expectations, toDelete))}
                                    data-cy={'Staffs-input-' + documentType}
                                />
                            </ExpectationCard>
                            { expectations.map(expectation => {
                                const role = getStudyRoleName(expectation.studyRoleId);
                                return(
                                    <ExpectationCard 
                                        key={expectation.id} 
                                        label={role.name} 
                                        indent 
                                        checked={isChecked(expectation.id, toDelete)}
                                    >
                                        <input
                                            name={expectation.id}
                                            type="checkbox"
                                            checked={toDelete.find(id => id === expectation.id) || false}
                                            onChange={() => setToDelete(toDelete => toggleSingleCheckbox(expectation.id, toDelete))}
                                            data-cy={expectation.id + 'Staffs-input-' + documentType}
                                        />
                                    </ExpectationCard>
                                );
                            })}
                        </div>
                    );
                }
            )}
        </div>
    );
};
